export const createEmptyOperationAddress = () => ({
  countryId: '',
  cityId: '',
  districtId: '',
  fullAddress: ''
});

export const normalizeOperationAddressValue = (value) => {
  if (typeof value === 'string') {
    return {
      ...createEmptyOperationAddress(),
      fullAddress: value
    };
  }

  if (!value || typeof value !== 'object') {
    return createEmptyOperationAddress();
  }

  return {
    countryId: value.countryId?._id || value.countryId || '',
    cityId: value.cityId?._id || value.cityId || '',
    districtId: value.districtId?._id || value.districtId || '',
    fullAddress: value.fullAddress || ''
  };
};
